import React, { useEffect, useState } from 'react';
// import '@style/components/hexagonGrid.scss';
import '../styles/components/hexagonGrid.scss';

function HexagonTile({ id, name, selectedId, onClickHandler }) {
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (selectedId === id) {
      setIsFocused(true);
    } else {
      setIsFocused(false);
    }
  }, [selectedId]);

  function handleClick() {
    if (onClickHandler) {
      onClickHandler(id);
    }
  }

  return (
    <>
      <div
        className={`hex-grid__item-background ${isFocused ? 'isFocused' : ''}`}
      />
      <li className="hex-grid__item" onClick={handleClick} tabIndex={0}>
        <p className="hex-grid__content">{name}</p>
      </li>
    </>
  );
}

export default HexagonTile;
